import React, { PropsWithChildren, useEffect, useState } from 'react';
import { TikTokEmbed } from 'react-social-media-embed';


/**
 * @interface IEmbedTikTokProps declares any input properties required for this component.
 */
export interface IEmbedTikTokProps extends PropsWithChildren<unknown> {
  url: string;
  postWidth: number | string;
  postHeight: number | string;
}

/**
 * @function EmbedTikTok is a React functional component for displaying a TikTok social media post.
 * @param {} props are the properties passed into the component.
 */
export const EmbedTikTok: React.FC<IEmbedTikTokProps> = (props: IEmbedTikTokProps) => {
  EmbedTikTok.displayName = 'EmbedTikTok';

  // whether to display console logs (displayConsoleLogs && console.log statements)
  const displayConsoleLogs: boolean = false;

  displayConsoleLogs && console.log(`EmbedTikTok. Entered EmbedTikTok`);

  const { url, postWidth, postHeight } = props;

  return (
    <>
      <TikTokEmbed url={url} width={postWidth} height={postHeight} />
    </>
  )
}
